import React from "react";

const Layout = ({ children }) => (<div style={{ padding: "10px" }}>{children}</div>)

export default Layout;
